module.exports = __webpack_public_path__ + "static/media/settings.e65495c3.svg";